import { cn } from "@lib/cn"

/**
 * Loading placeholder (PRD-60 chunk 0). Operate-mode rule: skeletons inside
 * content, spinners only at a route boundary. Every console surface used to
 * render `<PageLoader>`'s centred spinner for in-card fetches, so a page
 * jumped from "nothing" to "everything" with no sense of shape.
 *
 * Decorative by definition, so it is hidden from the accessibility tree; the
 * surrounding region carries `aria-busy` and the live announcement.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden className={cn("skeleton h-4 w-full", className)} />
}

/** `count` placeholder rows at `rowClassName` height. The list case. */
export function SkeletonRows({
  count = 4,
  rowClassName = "h-12",
  className,
}: {
  count?: number
  rowClassName?: string
  className?: string
}) {
  return (
    <div aria-hidden className={cn("space-y-2", className)}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={cn("skeleton", rowClassName)} />
      ))}
    </div>
  )
}
